<template>
  <div
    v-shortkey="['ctrl', '/']"
    class="d-flex flex-grow-1"
    style="height: calc(100% - 60px)"
  >
    <!-- Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      app
      floating
      class="elevation-1"
      :right="$vuetify.rtl"
      :light="menuTheme === 'light'"
      :dark="menuTheme === 'dark'"
    >
      <!-- Navigation menu info -->
      <template #prepend>
        <img
          src="/logo.png"
          alt="EnviaMas logo"
          style="width: 150px; margin: 20px 45px 0px;"
        >
      </template>

      <!-- Navigation menu -->
      <main-menu :menu="validateRole" />
    </v-navigation-drawer>

    <!-- Toolbar -->
    <v-app-bar
      app
      :color="isToolbarDetached ? 'surface' : undefined"
      :flat="isToolbarDetached"
      :light="toolbarTheme === 'light'"
      :dark="toolbarTheme === 'dark'"
    >
      <v-card
        class="flex-grow-1 d-flex card_toolbar"
        :class="[isToolbarDetached ? 'pa-1 mt-3 mx-1' : 'pa-0 ma-0']"
        :flat="!isToolbarDetached"
      >
        <div class="d-flex flex-grow-1 align-center">
          <v-app-bar-nav-icon @click.stop="toggleDrawer" />
          <v-spacer />

          <div :class="[$vuetify.rtl ? 'ml-1' : 'mr-1']">
            <toolbar-notifications
              @markdown-btn-click="openMarkdownLink"
             />
          </div>
          <toolbar-user />
        </div>
      </v-card>
    </v-app-bar>
        
    <v-main :style="($route?.path?.includes('/chat') && visibleNotification)? 'overflow-y: auto; height: 100vh;' : 'margin-top: 0px'">
      <div class="notifications-container p-2">
        <div v-if="visibleNotification.length">
          <v-card class="p-2 mb-2 card-transition" :color="cardColor">
            <transition name="text-slide" mode="out-in">
              <MarqueeBanner
                v-if="currentNotification"
                :key="currentNotification.user_notification_id"
                :title="currentNotification.title"
                :message="currentNotification.message"
                :speed="60"
                @markdown-btn-click="openMarkdownLink"
              />
            </transition>
          </v-card>
        </div>
      </div>
      
      <v-container
        style="margin-top: -20px;"
        fluid
      >
        <slot />
      </v-container>

      <v-footer
        app
        inset
      >
        <v-spacer />
        <div class="overline no-uppercase">
          EnviaMas® <span id="current-year"></span>
        </div>
      </v-footer>
    </v-main>

    <PrivacyConsentDialog
      :is-open="showPrivacyConsentDialog"
      :consent="privacyConsent"
      :policy-url="privacyPolicyUrl"
      :load-error="privacyConsentStatusError"
      @update:is-open="showPrivacyConsentDialog = $event"
      @accepted="onPrivacyConsentAccepted"
      @retry="resolvePrivacyConsentStatus"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BackendApi from '@/services/backend.service'
import config from '../configs'

import MainMenu from '../components/navigation/MainMenu'
import ToolbarUser from '../components/toolbar/ToolbarUser'
import ToolbarNotifications from '../components/toolbar/ToolbarNotifications.vue'
import MarqueeBanner from '../components/common/MarqueeBanner.vue'
import PrivacyConsentDialog from '../components/common/PrivacyConsentDialog.vue'
import { userRequiresPrivacyConsent } from '../constants/privacy'

export default {
  components: {
    MainMenu,
    ToolbarUser,
    ToolbarNotifications,
    MarqueeBanner,
    PrivacyConsentDialog,
  },
  props:{
    halloweenTematic:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      drawer: null,
      showSearch: false,
      navigation: config.navigation,
      menuNavigation:[],
      roles: {},
      chatRolesFetched: false,
      channel: null,
      showAlert: false,
      pending_notifications: [],
      pppp:[],
      currentIndex: 0,
      cycleTimer: null,
      displayMs: 1 * 60 * 1000,
      overflowing: false,
      showPrivacyConsentDialog: false,
      isResolvingPrivacyConsent: false,
      privacyPolicyUrl: '',
      privacyConsent: null,
      privacyConsentStatusError: null,
    }
  }, 
  computed: {
    cardColor() {
      if (!this.currentNotification) {
        return 'grey lighten-2'
      }
      return this.mapColor(this.currentNotification.type_name)
    },
    currentNotification() {
      return this.visibleNotification[this.currentIndex] || null
    },
    ...mapState('app', ['product', 'isContentBoxed', 'menuTheme', 'toolbarTheme', 'isToolbarDetached']),
    validateRole () {

      const role_user = $cookies.get('user')?.role_id ?? -1
      const isOwner = $cookies.get('chat_roles')?.isChatOwner ?? false
      const isSupervisor = $cookies.get('chat_roles')?.isChatSupervisor ?? false
      const isAgent = $cookies.get('chat_roles')?.isChatAgent ?? false
      const user_id = $cookies.get('user')?.id ?? -1
      const user_services = $cookies.get('services') ?? []

      let menu = []

      if (role_user === 1 || user_id === 389) {
        menu = [...config.navigation.menu]
      } else if (role_user === 2) {
        menu = config.navigation.menu.filter( (e) => (e.text !== 'Canales' && e.text !== 'Otros'))
      } else if (role_user > 2) {
        menu = config.navigation.menu.filter( (e) => (e.text !== 'Canales' && e.text !== 'Otros'))
      }
      
      // Mostrar "Lista negra" si el usuario tiene 3 o 5 en su array user_services
      const serviceIds = Array.isArray(user_services)
        ? user_services.map(s => typeof s === 'object' ? s.service_id : s)
        : []

      if (!(serviceIds.includes(3) || serviceIds.includes(5))) {
        menu[3].items = config.navigation.menu[3].items.filter((e) => e.text !== 'Lista negra')
      }

      //Deshabilitar Hipervision (No está en uso)
      menu[2].items[0].items = config.navigation.menu[2].items[0].items.filter( (e) => (e.text !== 'Hipervision'))
      //
      if (isOwner || isSupervisor) {
        if (!isOwner) {
          menu[2].items[0].items = config.navigation.menu[2].items[0].items.filter( (e) => (e.text !== 'Permisos de Meta'))
          menu[2].items[0].items = config.navigation.menu[2].items[0].items.filter( (e) => (e.text !== 'Workgroups' && e.text !== 'Hipervision' && e.text !== 'Configuración' ))
        }
        if (!isSupervisor) {
          menu[2].items[0].items = config.navigation.menu[2].items[0].items.filter( (e) => (e.text !== 'Supervisar'))
        }

      }
      else {
        menu = menu.filter( (e) => (e.text !== 'Atención al cliente'))
      }

      if (!isAgent) {
        menu = menu.filter( (e) => (e.text !== 'Chat'))
      }

      if (user_id !== 1) {
        menu = menu.filter( (e) => (e.text !== 'Soporte'))
      }

      return menu
    },
    ...mapState({ 
      pusher: (state) => state.sockets.pusher,
      notifications: (state) => state.general.notifications
    }),
    ...mapGetters('general', [
      'visibleNotification'
    ]),
    notificationColor() {
      if (!this.visibleNotification) return 'white' // Color por defecto
      
      switch (this.visibleNotification.type_name) {

      case 'ERROR': return '#feb2a1'
      case 'WARNING': return 'fbf2a2'
      case 'SUCCESS': 
      default: return '#bbfdc0'
      }
      
    }

  },
  watch: {
    visibleNotification() {
      this.startCycle()
    },
    '$route'(to, from) {

      this.adjustDrawerVisibility()
    },
    beforeRouteEnter(to, from, next) {

      next((vm) => {

        vm.adjustDrawerVisibility()
      })
    }
  },  
  async mounted() {
    this.startCycle()
    document.getElementById('current-year').textContent = new Date().getFullYear()
    this.channel = this.pusher?.subscribe('notifications_')

    await this.$store.dispatch('general/getNotifications', this)
    this.listenNewNotifications()
  }, 
  destroyed() {
    if (this.channel) {
      this.channel.unbind('user_id_' + $cookies.get('user').id)
    }
  },
   beforeDestroy() {
    clearTimeout(this.cycleTimer)
  },
  async created() {
    if (this.$route.path === '/tools/chat') {
      this.drawer = false
    }

    this.channel = this.pusher.subscribe('notifications_')
    this.identifyUser()
    this.hydratePrivacyPolicyFromSession()
    await this.resolvePrivacyConsentStatus()
  },
  methods: {
    hydratePrivacyPolicyFromSession() {
      if (!this.isPrivacyConsentRole() || this.isImpersonatedSession()) {
        return
      }
      try {
        const raw = sessionStorage.getItem('privacy_policy_payload')
        if (raw) {
          this.applyPrivacyPolicyContent(JSON.parse(raw))
        }
      } catch (error) {
        console.warn('Invalid privacy_policy_payload in sessionStorage, clearing cache.', error)
        sessionStorage.removeItem('privacy_policy_payload')
      }
    },
    isPrivacyConsentRole() {
      return userRequiresPrivacyConsent($cookies.get('user')?.role_id)
    },
    isImpersonatedSession() {
      const value = $cookies.get('is_impersonated_session')

      return value === true || value === 'true'
    },
    applyPrivacyPolicyContent(data) {
      if (!data) {
        return
      }
      if (data.policy_url) {
        this.privacyPolicyUrl = data.policy_url
      }
      if (data.consent) {
        this.privacyConsent = data.consent
      }
    },
    applyPrivacyConsentStatusFromServer(needsPrivacyConsent) {
      $cookies.set('needs_privacy_consent', needsPrivacyConsent)
      this.showPrivacyConsentDialog = needsPrivacyConsent
    },
    handlePrivacyConsentStatusFailure() {
      const message =
        'No se pudo verificar el estado del consentimiento. Intente de nuevo.'
      const mayNeedConsent =
        $cookies.get('needs_privacy_consent') === true ||
        $cookies.get('needs_privacy_consent') === 'true'

      this.privacyConsentStatusError = message

      if (mayNeedConsent) {
        this.showPrivacyConsentDialog = true
        return
      }

      this.$store.dispatch('app/showError', {
        error: { message },
      })
    },
    async resolvePrivacyConsentStatus() {
      if (
        !this.isPrivacyConsentRole() ||
        this.isImpersonatedSession() ||
        this.isResolvingPrivacyConsent
      ) {
        return
      }

      this.isResolvingPrivacyConsent = true
      this.privacyConsentStatusError = null

      try {
        const response = await BackendApi.get('/audit/privacy-policy/status')
        if (!response?.data?.success) {
          this.handlePrivacyConsentStatusFailure()
          return
        }

        this.applyPrivacyPolicyContent(response.data.data)
        this.applyPrivacyConsentStatusFromServer(
          Boolean(response.data.data.needs_privacy_consent)
        )
      } catch (error) {
        console.error('Error resolving privacy consent status', error)
        this.handlePrivacyConsentStatusFailure()
      } finally {
        this.isResolvingPrivacyConsent = false
      }
    },
    onPrivacyConsentAccepted() {
      this.showPrivacyConsentDialog = false
      this.privacyConsentStatusError = null
      $cookies.set('needs_privacy_consent', false)
      try {
        const raw = sessionStorage.getItem('privacy_policy_payload')
        if (raw) {
          const payload = JSON.parse(raw)
          payload.needs_privacy_consent = false
          sessionStorage.setItem('privacy_policy_payload', JSON.stringify(payload))
        }
      } catch (error) {
        console.warn('Invalid privacy_policy_payload in sessionStorage, clearing cache.', error)
        sessionStorage.removeItem('privacy_policy_payload')
      }
    },
    onMeasured({ itemWidth, containerWidth }) {
      
      this.overflowing = itemWidth > containerWidth
    },

    mapColor(type) {
      switch (type) {
        case 'ERROR':   return '#ffcece'
        case 'WARNING': return '#fbf2a2'
        case 'SUCCESS': return '#bbfdc0'
        default:        return 'primary'
      }
    },

    identifyUser() {
      if (!$cookies.get('user')) {
        this.$store.dispatch('app/showError', { error: { message: 'La sesión ha caducado.' } })
        this.$router.push('/auth/signin')

        return
      }
      //To do: fix this
      const user_email = $cookies.get('user').email
    },
    listenNewNotifications() {  
      this.channel.unbind('user_id_' + $cookies.get('user').id)
      this.channel.bind('user_id_' + $cookies.get('user').id, (data) => {
        this.$store.dispatch('general/handleNewNotification', data)
      })
    },
    filternavigation () {
      return config.navigation.menu.filter( (e) => (e.text !== 'Canales' /*&& e.text !== 'Otros' && e.text !== 'Chat'*/) )
    },
    toggleDrawer() {

      this.drawer = !this.drawer
    },
    adjustDrawerVisibility() {
 
      if (this.$route.path === '/tools/chat' || this.$route.path.startsWith('/tools/chat/workgroup')) {
        this.drawer = false 
      } else {
        this.drawer = true 
      }
    },
    async getServices() {
      try {
        const response = await BackendApi.get('/userServices')

        if (!response?.data?.success || !response?.data?.data) {
          throw new RequestError(response)
        }

        this.services = response.data.data.filter((service) => [1, 3].includes(service.service_id)) // sms y whatsapp
        //this.services = response.data.data
        
      } catch (error) {
        CustomException.handleError({ rootMethod: 'getServices', error }, this)
      }
    },

    startCycle() {
      this.overflowing = false
      clearTimeout(this.cycleTimer)
      if (!this.visibleNotification.length) {
        this.currentIndex = 0
        return
      }
      
      this.currentIndex = this.currentIndex % this.visibleNotification.length
      
      this.cycleTimer = setTimeout(() => {
        
        this.currentIndex =
          (this.currentIndex + 1) % this.visibleNotification.length
        this.startCycle()
      }, this.displayMs)
    },
    openMarkdownLink(url) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  }
}
</script>

<style scoped>
.buy-button {
  box-shadow: 1px 1px 18px #ee44aa;
}

.card_toolbar{
 background: transparent;
}
.card-transition {
  transition: background-color 1s ease-in-out;
}

.text-slide-enter-active,

.text-slide-leave-active {
  transition: opacity 0.8s ease-in-out, transform 0.8s ease-in-out;
}

.text-slide-enter {
  opacity: 0;
  transform: translateX(-40px);
}
.text-slide-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.text-slide-leave {
  opacity: 1;
  transform: translateX(0);
}
.text-slide-leave-to {
  opacity: 0;
  transform: translateX(40px);
}
.notification-text {
  display: inline-block;
}

.notification-marquee {
  display: block;
  width: 100%;
  line-height: 1.2em;
  max-height: 2.4em;
  overflow: hidden;
  white-space: nowrap;
}
@media (max-width: 600px) {
  .notification-marquee {
    max-height: 2.4em;
    font-size: 0.9rem;
  }
}
</style>
